"use client";

import State from "@/components/state";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";

export default function NotFoundPage() {
  return (
    <State
      icon={ExclamationTriangleIcon}
      title="404"
      description="Pagina non trovata"
      action={{
        text: "Torna indietro",
        onClick: () => window.history.back(),
      }}
    />
  );
}
